export const ModelsKind = [
  {
    uid: 'b4b89b51-bfe8-42fb-938c-0223aa56fbf4',
    typeBenefit: null,
    label: 'Carta de abertura de banco',
    slug: 'carta_banco',
    tags: []
  },
  {
    uid: '5f431a63-365c-47da-8fe7-32e3f9455d2b',
    typeBenefit: '3c2e4354-768f-4dc0-a783-ad94e0e48c64',
    label: 'Aluguel Veicular',
    slug: 'aluguel_veicular',
    tags: []
  },
  {
    uid: 'a1f6e845-c185-44dc-9383-94037f30b8eb',
    typeBenefit: '64b879be-f2cf-430b-a47d-7ad674b62459',
    label: 'Assistência Odontológica',
    slug: 'plano_odontologico',
    tags: []
  },
  {
    uid: '1275fc37-a8f3-4e47-a459-74e34b939cdf',
    typeBenefit: '08662463-4bd9-4224-8e27-09fcac91a1c8',
    label: 'Combo VA VR',
    slug: 'combo_vrva',
    tags: []
  },
  {
    uid: '3dd86979-07df-4cff-a76c-812bfe4e4500',
    typeBenefit: null,
    label: 'Contrato de Trabalho',
    slug: 'contrato_trabalho',
    tags: []
  },
  {
    uid: '221a023c-eac5-4726-bde4-57f46da1837a',
    typeBenefit: '0d672cdd-4719-421e-8ae6-31f9ef5e34c1',
    label: 'Estacionamento',
    slug: 'estacionamento',
    tags: []
  },
  {
    uid: 'ecd1e7e1-4374-4654-a684-38b4876b7e7f',
    typeBenefit: '1fefbd30-2056-4ad6-903e-9235e7bc6afb',
    label: 'Fretado',
    slug: 'fretado',
    tags: []
  },
  {
    uid: 'e997c6fa-68e6-4582-a72b-92bc2889e7f7',
    typeBenefit: '59da7250-9740-4792-99ea-b73e22f915f3',
    label: 'Gasolina',
    slug: 'gasolina',
    tags: []
  },
  {
    uid: '5c82dbcc-4649-4b9b-a1a0-e4ab9db5a822',
    typeBenefit: null,
    label: 'Genérico',
    slug: 'generico',
    tags: []
  },
  {
    uid: '6d5140e0-3b40-4def-b654-f33963f347c3',
    typeBenefit: '165544c0-bf16-4880-8db9-b9815733acd3',
    label: 'Plano de Saúde',
    slug: 'plano_saude',
    tags: []
  },
  {
    uid: '7733b67f-0afd-4678-b5e8-3d51db387524',
    typeBenefit: '77951cff-6986-4fef-be7e-8aa598191ff5',
    label: 'Seguro de Vida',
    slug: 'seguro_vida',
    tags: []
  },
  {
    uid: '97783289-4c61-4733-a3f3-7fe95a7296af',
    typeBenefit: '0e522d50-a60e-4ae0-b21a-97457ee33fe2',
    label: 'Vale Alimentação',
    slug: 'va',
    tags: []
  },
  {
    uid: 'a228b72c-f4f5-44af-95e2-2ff1d2bf729c',
    typeBenefit: 'fa5e6ece-e179-4a10-9b56-ebb33f28df15',
    label: 'Vale Refeição',
    slug: 'vr',
    tags: []
  },
  {
    uid: 'a00e3242-18f3-41a4-a8d4-ae68785868a0',
    typeBenefit: 'f5887287-442e-4237-a738-31130ecf350a',
    label: 'Vale Transporte',
    slug: 'vt',
    tags: []
  },
  {
    uid: '16cf3750-96d3-4ed5-9f3b-778858396d43',
    typeBenefit: null,
    label: 'Declaração de Dependentes - Imposto de Renda',
    slug: 'ir',
    tags: []
  },
  {
    uid: '97d2f426-60b2-41d7-bab1-a07a11b18d79',
    typeBenefit: null,
    label: 'Termo de Responsabilidade - Salário Família',
    slug: 'sf',
    tags: []
  },
  {
    uid: '1e385213-4370-4919-b99b-bfe5f54af6ba',
    typeBenefit: '7112bfc7-cf2f-4fc0-a3bf-44c0314c9146',
    label: 'Refeitório',
    slug: 'refeitorio',
    tags: []
  },
  {
    uid: 'ea3ef13b-942b-420a-a13b-f840749d1cb4',
    typeBenefit: 'cd50b1c2-591d-4989-92f0-aa370ea86110',
    label: 'Combo Refeitório VA',
    slug: 'combo_refeitorio_va',
    tags: []
  },
  {
    uid: 'afc607b5-213c-4310-bb5f-2a96c89a0e63',
    typeBenefit: '55638d44-9767-48aa-8d6c-93546318242d',
    label: 'Cesta Básica',
    slug: 'cesta_basica',
    tags: []
  }
];
